import { DefaultTheme, ThemeProps } from 'styled-components';
import { TokenName } from '@mewssystems/design-tokens';
import { getToken, Status } from '@optimus-web/common';
import { InputWrapperProps } from './style';

type ThemeAndComponentProps = ThemeProps<DefaultTheme> & InputWrapperProps;
type FieldStates = 'default' | 'disabled' | 'error' | 'focused';
type VariantStates = Record<FieldStates, ((props: ThemeProps<DefaultTheme>) => string) | string>;

const getVariantAndState = ({ $disabled, status, focused }: ThemeProps<DefaultTheme> & InputWrapperProps) => {
    let state: FieldStates = 'default';

    if (status === Status.Error && !$disabled) {
        state = 'error';
    } else if ($disabled) {
        state = 'disabled';
    } else if (focused) {
        state = 'focused';
    }

    return state;
};

export const getTextColor = (props: ThemeAndComponentProps) => {
    const getTextColorTokens: VariantStates = {
        focused: getToken(TokenName.TEXT_STATIC_PRIMARY),
        error: getToken(TokenName.TEXT_STATIC_PRIMARY),
        disabled: getToken(TokenName.BORDER_DISABLED),
        default: 'inherit',
    };

    return getTextColorTokens[getVariantAndState(props)];
};

export const getBorderColor = (props: ThemeAndComponentProps) => {
    const getBorderColorTokens: VariantStates = {
        focused: getToken(TokenName.BORDER_INTERACTIVE_FOCUS),
        error: getToken(TokenName.BORDER_ALERT_DANGER),
        disabled: getToken(TokenName.BORDER_DISABLED),
        default: getToken(TokenName.BORDER_INTERACTIVE_SECONDARY_DEFAULT),
    };

    return getBorderColorTokens[getVariantAndState(props)];
};
